export default Object.freeze({
  None: 'NONE',
  Verbose: 'VERBOSE',
  Debug: 'DEBUG',
  Info: 'INFO',
  Warn: 'WARN'
});
